module.exports = __webpack_public_path__ + "media/images/homes/IntelligentReporting-05c475e1381982229b58b4b50176077e.png";